export default __webpack_public_path__ + "static/media/package_1.611126ca.png";